import { render, staticRenderFns } from "./AprovacaoSolicitacaoDetalhesProdutos.vue?vue&type=template&id=12e0bd9c&"
import script from "./AprovacaoSolicitacaoDetalhesProdutos.vue?vue&type=script&lang=js&"
export * from "./AprovacaoSolicitacaoDetalhesProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCol,VDivider,VRow,VSubheader})
